import { renderClasses } from 'Shared/Helper/Bem/Bem';
import { findOne } from 'Shared/Helper/Dom/Dom';

const NAME = 'search-filter';

const MESSAGE_HANDLERS = [
    'searchFiltersSummaryAnchorClicked.all',
];

const CLASSES = {
    'collapsed': renderClasses(NAME, null, ['collapsed']),
    'content': renderClasses(NAME, 'content'),
    'hint': renderClasses(NAME, 'hint'),
    'hintHidden': renderClasses(NAME, 'hint', ['hidden']),
};

const SELECTORS = {
    'content': `.${CLASSES.content}`,
    'hint': `.${CLASSES.hint}`,
};

function searchFilterControllerFactory (dependencies) {
    return class SearchFilterController extends dependencies.componentController {
        onCollapseToggleClick () {
            this.element.classList.toggle(CLASSES.collapsed);
        }

        onFilterLinkClick (evt) {
            if (evt.target.nodeName == 'BUTTON') {
                evt.preventDefault();
            }
        }

        onSearchFiltersSummaryAnchorClicked (evt) {
            const evtAnchor = evt.data.data.anchor;
            const filterAnchor = this.data.get('anchor');

            if (evtAnchor === filterAnchor) {
                this.element.scrollIntoView({
                    'block': 'start',
                    'behavior': 'smooth',
                });
            }
        }

        onShowHintClick (evt) {
            evt.preventDefault();
            evt.stopPropagation();

            const hint = findOne(SELECTORS.hint, this.element);
            hint.classList.toggle(CLASSES.hintHidden);
        }

        get componentName () {
            return NAME;
        }

        get messageHandlers () {
            return MESSAGE_HANDLERS;
        }
    };
}

export { searchFilterControllerFactory };
